/** Query param name for temporary guest-route URL access tokens. */
export const GUEST_ROUTE_ACCESS_TOKEN_QUERY_PARAM = 'accessToken';

/** JWT `purpose` claim values for guest-route access tokens. */
export enum GuestRouteAccessPurpose {
  PublicAppointmentRead = 'public-appointment-read'
}
